import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';

const AdminNotFound = () => (
  <PageLayout title="Страница не найдена">
    <div className="flex items-center justify-center py-10">
      <div className="w-full max-w-2xl rounded-xl border border-slate-200 bg-white p-8 shadow-sm text-center">
        <h2 className="mt-3 text-2xl font-bold text-gray-900">Запрошенная страница отсутствует</h2>
        <p className="mt-2 text-gray-600">
          Проверьте адрес или вернитесь к списку приложений в панели администратора.
        </p>
      </div>
    </div>
  </PageLayout>
);

export default AdminNotFound;
